export const pdfAssets = '/pdfjs/5.4.624/';
let runtime;
export function loadPdfRuntime() {
    if (!runtime) {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = `${pdfAssets}pdf_viewer.css`;
        document.head.appendChild(css);
        runtime = import(/* webpackIgnore: true */ `${pdfAssets}build/pdf.js`).then(pdfjs => {
            pdfjs.GlobalWorkerOptions.workerSrc = `${pdfAssets}build/pdf.worker.js`;
            return pdfjs;
        }).catch(error => { runtime = null; throw error; });
    }
    return runtime;
}

export function isPdf(document) {
    return String(document.extension || '').toLowerCase() === 'pdf';
}

export function hasFillableFields(fields) {
    return Object.values(fields || {}).flat().some(field =>
        ['text', 'checkbox', 'radiobutton', 'combobox', 'listbox'].includes(field.type) && field.editable !== false);
}

let scrollLocks = 0;
let restoreBackground;
export function lockBackgroundScroll() {
    if (scrollLocks++ === 0) {
        const { body, documentElement } = document;
        const x = window.scrollX, y = window.scrollY;
        const saved = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'].map(property =>
            [property, body.style.getPropertyValue(property), body.style.getPropertyPriority(property)]);
        const overflow = documentElement.style.overflow;
        const gutter = window.innerWidth - documentElement.clientWidth;
        const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        Object.assign(body.style, { position: 'fixed', top: `${-y}px`, left: `${-x}px`, width: '100%', overflow: 'hidden', paddingRight: `${padding + gutter}px` });
        documentElement.style.overflow = 'hidden';
        restoreBackground = () => {
            saved.forEach(([property, value, priority]) => body.style.setProperty(property, value, priority));
            documentElement.style.overflow = overflow;
            window.scrollTo({ left: x, top: y, behavior: 'instant' });
        };
    }
    let released = false;
    return () => {
        if (released) return;
        released = true;
        if (--scrollLocks === 0) restoreBackground();
    };
}

// All document surfaces use one viewer host so navigation can guard unsaved edits.
export function openDocument(document) {
    window.dispatchEvent(new CustomEvent('c2c:open-pdf', { detail: document }));
}

export const openPdf = openDocument;

// With scripting disabled, PDF.js can reuse the original appearance text when a
// widget is remounted. Keep its display value in annotation storage as well.
export function syncTextAppearances(pdf, fieldObjects) {
    Object.values(fieldObjects || {}).flat().filter(field => field.type === 'text').forEach(field => {
        const stored = pdf.annotationStorage.getValue(field.id, {});
        if (typeof stored.value === 'string') {
            pdf.annotationStorage.setValue(field.id, { formattedValue: stored.value });
        }
    });
}

export function formAnnotations(pdf, annotations) {
    return annotations.filter(annotation => annotation.subtype === 'Widget'
        && ['Tx', 'Btn', 'Ch'].includes(annotation.fieldType) && !annotation.pushButton).map(annotation => {
        const stored = pdf.annotationStorage.getValue(annotation.id, {});
        return annotation.fieldType === 'Tx' && typeof stored.value === 'string'
            ? { ...annotation, textContent: [stored.value] } : annotation;
    });
}
